import React from 'react'

const CustomDocumentName = ({ formData, errors, handleInputChange, isDark, isRequired = false }) => {
  if (!formData?.sending && formData?.recipientSource !== 'non-strata') return null

  const errorValue = errors?.custom_document_name
  const errorMessage = typeof errorValue === 'string'
    ? errorValue
    : errorValue
      ? 'Only letters, numbers, and spaces are allowed.'
      : ''

  return (
    <div className={`box-border content-stretch flex flex-col gap-[16px] items-start p-[20px] relative rounded-[16px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] border-none w-full max-w-[822px] transition-colors duration-200 ${
      isDark ? 'bg-[#000000]' : 'bg-white'
    }`}>
      <span className={`font-medium text-[16px] leading-normal transition-colors duration-200 ${
        isDark ? 'text-white' : 'text-[#072837]'
      }`}>
        {(isRequired || formData?.recipientSource === 'non-strata')
          ? 'Customise document name as it should appear in SMATA/Bingmail'
          : 'Customise document name as it should appear in SMATA'}
        {isRequired && <span className="text-[#FF0000] ml-[4px]">*</span>}
      </span>
      <div className={`border-none rounded-[8px] p-[12px] flex items-center w-full transition-colors duration-200 focus-within:border-solid focus-within:border-[1px] focus-within:border-[#CD6D2C] ${
        isDark ? 'bg-[#161515]' : 'bg-[#f5f5f5] border-solid border-[1px] border-[#f8f9fa]'
      }`}>
        <input
          className={`flex-1 bg-transparent border-0 outline-none text-[16px] transition-colors duration-200 ${
            isDark
              ? 'text-white placeholder:text-[#b3b3b3]'
              : 'text-[#686868] placeholder:text-[#686868]'
          }`}
          type="text"
          placeholder="Enter document name"
          aria-label="Document name"
          aria-required={isRequired || undefined}
          value={formData.custom_document_name}
          onChange={e => handleInputChange('custom_document_name', e.target.value)}
        />
        <div className={`w-[1px] h-[30px] shrink-0 mx-[12px] transition-colors duration-200 ${
          isDark ? 'bg-[#292929]' : 'bg-[#d9d9d9]'
        }`} />
        <span className={`text-[16px] font-medium whitespace-nowrap transition-colors duration-200 ${
          isDark ? 'text-[#b3b3b3]' : 'text-[#686868]'
        }`}>.pdf</span>
      </div>
      {errorMessage && (
        <div className="text-[14px] font-semibold text-[#FF0000]">{errorMessage}</div>
      )}
    </div>
  )
}

export default CustomDocumentName


